import { styled } from 'styled-components';

export const EmailCaptchaWrapper = styled.div`
  position: relative;
  padding-top: 10px;
`;

export const EmailErrorContent = styled.div`
  position: relative;
  width: 96%;
  left: 2%;
  top: 0;
  margin-bottom: 30px;
`;

export const EmailError = styled.div`
  background: var(--pcm-error-background);
  border-radius: 28px;
  line-height: 1;
  display: flex;
  align-items: center;
  color: var(--pcm-error-color);
  padding: 8px 8px;
  line-height: 1.2;
  display: flex;
`;

export const EmailErrorLeft = styled.div`
  min-width: 20px;
  width: 20px;
`;

export const EmailErrorRight = styled.div`
  flex: 1;
  font-size: 12px;
`;

export const EmailCaptchaTip1 = styled.div`
  font-size: 14px;
`;

export const EmailText = styled.div`
  font-size: 14px;
  font-weight: bold;
  margin-top: 4px;
`;

export const EmailMainIcon = styled.div`
  margin: auto;
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  height: 80px;
  position: relative;
`;

export const EmailInfo = styled.div`
  text-align: center;
  margin-bottom: 30px;
`;

export const EmailIconDiv = styled.div`
  position: relative;
  width: 70px;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Spin = styled.div`
  display: inline-block;
  animation: spin 1.2s linear infinite;
  position: absolute;
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
